var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scorllFlash",attrs:{"id":_vm.randomId}},[(!_vm.noNeedFlash)?_c('div',{staticClass:"reloadFlash"},[_vm._v("刷新中···")]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"position":"relative","z-index":"1"},attrs:{"id":_vm.randomId + '_translation'}},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18d9ccc6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/myComponents/allScorllPlace.vue
// module id = null
// module chunks = 